import { render, staticRenderFns } from "./archival.vue?vue&type=template&id=0aa3daee&scoped=true&"
import script from "./archival.vue?vue&type=script&lang=js&"
export * from "./archival.vue?vue&type=script&lang=js&"
import style0 from "./archival.vue?vue&type=style&index=0&id=0aa3daee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3daee",
  null
  
)

export default component.exports